var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-source-tag"},[_c('div',{staticClass:"tag-icon-wrapper"},[_c('font-awesome-icon',{staticStyle:{"color":"#cbbdd0","font-size":"11px","opacity":"0.8"},attrs:{"icon":['fas', 'lightbulb']}})],1),_c('span',{staticClass:"tag-text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('generated_by_ai')))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }